var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/display-name */
import * as React from 'react';
var SvgFolderOpen = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ viewBox: "0 0 24 24" }, props, { ref: ref }),
    React.createElement("path", { d: "M23.44 9.549A1.492 1.492 0 0022.28 9H10.42a.5.5 0 01-.491-.4l-.278-1.395A1.5 1.5 0 008.18 6H1.72A1.5 1.5 0 00.249 7.8l2.6 13A1.5 1.5 0 004.32 22h15.961a1.5 1.5 0 001.47-1.2l2-10a1.5 1.5 0 00-.311-1.251zM3.22 5a1 1 0 00.98-.778A.263.263 0 014.443 4H19.72a.5.5 0 01.5.5V7a1 1 0 002 0V4a2 2 0 00-2-2h-16a2 2 0 00-2 2 1 1 0 001 1z" }))); });
export default SvgFolderOpen;
//# sourceMappingURL=FolderOpenIcon.js.map